export enum ReminderCategory {
  VACCINATION = 'VACCINATION',
  CHECKUP = 'CHECKUP',
  MEDICATION = 'MEDICATION',
  APPOINTMENT = 'APPOINTMENT',
  FOLLOW_UP = 'FOLLOW_UP',
  GROOMING = 'GROOMING',
  DENTAL = 'DENTAL',
  PARASITE_PREVENTION = 'PARASITE_PREVENTION',
  LAB_WORK = 'LAB_WORK',
  PRESCRIPTION_REFILL = 'PRESCRIPTION_REFILL',
  OTHER = 'OTHER'
}

export enum ReminderStatus {
  PENDING = 'pending',
  SENT = 'sent',
  COMPLETED = 'completed',
  CANCELLED = 'cancelled',
  FAILED = 'failed'
}

export enum ReminderPriority {
  LOW = 'low',
  NORMAL = 'normal',
  HIGH = 'high',
  URGENT = 'urgent'
}

export enum DeliveryMethod {
  EMAIL = 'EMAIL',
  SMS = 'SMS',
  PUSH = 'PUSH',
  IN_APP = 'IN_APP'
}

export enum DeliveryStatus {
  QUEUED = 'queued',
  SENT = 'sent',
  DELIVERED = 'delivered',
  FAILED = 'failed',
  BOUNCED = 'bounced'
}

export interface ReminderType {
  id: string;
  practice_id: string | null;
  name: string;
  category: ReminderCategory;
  description?: string;
  default_interval_days: number;
  is_enabled: boolean;
  is_system_default: boolean;
  notification_template?: any;
  created_at: string;
  updated_at: string;
}

export interface Reminder {
  id: string;
  pet_id: string;
  practice_id: string;
  reminder_type_id: string;
  reminder_type?: ReminderType;
  due_date: string;
  scheduled_send_time?: string;
  status: ReminderStatus;
  priority: ReminderPriority;
  delivery_method?: string;
  title: string;
  message?: string;
  notes?: string;
  created_at: string;
  updated_at: string;
  sent_at?: string;
  completed_at?: string;
  // Source type for delete routing: "regular", "form_trigger", "immunization_reminder"
  source_type?: 'regular' | 'form_trigger' | 'immunization_reminder';
}

export interface ReminderLog {
  id: string;
  reminder_id: string;
  pet_id?: string;
  pet_owner_id?: string;
  delivery_method: DeliveryMethod;
  status: DeliveryStatus;  // Backend sends 'status', not 'delivery_status'
  recipient: string;
  sent_at: string;
  delivered_at?: string;
  error_message?: string;
  message_id?: string;
  notification_content?: Record<string, any>;
  pet_name?: string;
  reminder_type_name?: string;
  created_at?: string;
  updated_at?: string;
}

